@if (isLineWidget) {
  <div>
    <scitis-line-widget-settings-time-range
      (timePeriodChanged)="onTimePeriodChange($event)"
      (formIsValid)="onValidTimePeriodChanged($event)"
      [timePeriod]="{timeValue: userDefinedWidget.userDefinedChartDetails.rangeValue, rangeType: userDefinedWidget.userDefinedChartDetails.rangeType}">
    </scitis-line-widget-settings-time-range>
    <h5 class="h5">
      <span translate>Y-axis</span>
      <scitis-required-field-indicator></scitis-required-field-indicator>
    </h5>
    @if (!userDefinedWidget.userDefinedChartDetails.axis || userDefinedWidget.userDefinedChartDetails.axis.length===0) {
      <div
        class="alert alert-info text-center">
        <span translate>Currently no y-axis has been added, please add one below.</span>
      </div>
    }
    <ul class="list-group mb-3">
      @for (axis of userDefinedWidget.userDefinedChartDetails.axis; track axis) {
        <scitis-line-widget-axis-display
          (axisDeleteEvent)="onAxisDelete($event)"
          (axisSettingsChanged)="onAxisSettingsChanged($event)"
          (axisStartEditEvent)="onAxisStartEdit($event)"
          [axisSettings]="axis"
          [isSelectedAxis]="this.selectedAxis.get(axis.id)"
          [usableSignals]="usableSignals"
          [usedSignalIds]="usedSignalIds">
        </scitis-line-widget-axis-display>
      }
    </ul>
    <button (click)="onAddNewAxis()" class="btn btn-primary">
      <span class="fa-solid fa-plus mr-1"></span>
      <span translate>Add y-axis</span>
    </button>
  </div>
}
